module.exports = __webpack_public_path__ + "static/media/icon-dashboard-pending-deal.4c83df11.svg";